// Border Radius Configuration
// Adjust these values to change border radius throughout the entire app

export const RADIUS_CONFIG = {
  // Small elements (buttons, chips, small cards)
  small: '8px',
  
  // Medium elements (input fields, buttons, alerts)
  medium: '12px',
  
  // Large elements (cards, papers, dialogs)
  large: '16px',
  
  // Extra large elements (main containers)
  xl: '20px',
  
  // Fully rounded (avatars, badges)
  round: '50%',
  
  // Progress bars, sliders
  thin: '6px',
};

// Helper function to get radius value
export const getRadius = (size = 'medium') => {
  return RADIUS_CONFIG[size] || RADIUS_CONFIG.medium;
};

// CSS custom properties for dynamic updates
export const injectRadiusVariables = () => {
  const root = document.documentElement;
  Object.entries(RADIUS_CONFIG).forEach(([key, value]) => {
    root.style.setProperty(`--radius-${key}`, value);
  });
};

// Usage examples:
// import { getRadius, RADIUS_CONFIG } from './styles/radius-config';
// 
// // In component:
// sx={{ borderRadius: getRadius('large') }}
// 
// // Or directly:
// sx={{ borderRadius: RADIUS_CONFIG.xl }}







